import React from 'react';

const GlampingDescription: React.FC = () => {
    const isMobile = /Mobi/i.test(window.navigator.userAgent);
    return (
        <div className="md:px-16 text-center pt-16 mb-8 -mt-4">
            <img src="images/Date.png" alt="Glamping-Date" className="inline md:w-[40svw] object-center px-14"/>
            {!isMobile && (
                <img src="images/Quinoccio-horizontal.png" alt="Glamping" className="w-full object-center -mt-20"/>
            )}
            {isMobile && (<img src="images/Quinoccio-vertical.png" alt="Glamping"
                  className="inline w-full md:w-[35svw] object-center md:px-14 px-4"/>)
            }
        </div>
    );
};

export default GlampingDescription;
